var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-0 white rounded-5 pa-2 my-2"},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',{staticClass:"mb-2 elemento-form"},[_c('span',_vm._g(_vm._b({staticClass:"text-medium text-primary font-normal elemento-form"},'span',attrs,false),on),[_vm._v(_vm._s(_vm.Titulo))])])]}}])},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.ToolTip)}})]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }